import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output} from '@angular/core';
import {DbResponse} from "../../shared/interceptors/db-response";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {ActivatedRoute, Router} from "@angular/router";
import {DbServerErrors} from "../../shared/interceptors/db-server-errors";
import {filter, first} from "rxjs/operators";
import {UserSubscription} from "../../user/user-subscription";
import {Website} from "../../websites/website/website";
import {UserService} from "../../user/user.service";
import {Store} from "@ngrx/store";
import {DbStoreState} from "../../store/reducers";
import {ReCaptchaV3Service} from "ngx-captcha";
import {Subject} from "rxjs";
import {PluginConnectService} from "../../shared/services/plugin-connect/plugin-connect.service";
import {AuthService} from "../auth.service";

@Component({
    selector: 'db-2fa-verification',
    templateUrl: './twoFaVerification.component.html',
    styleUrls: ['./twoFaVerification.component.scss'],
    standalone: false
})
export class TwoFaVerificationComponent implements OnInit, AfterViewInit, OnDestroy {

  @Input() email: any;
  @Input() password: any;
  @Input() isLoginFromManager: any;
  @Input() _isLoginFromZendesk: any;
  @Input() enabledRecaptcha: any;
  @Output() loginWith2fa = new EventEmitter<any>();
  public loading: boolean;
  public formSubmitted: boolean;
  public login2faForm: FormGroup;
  public serverErrors: DbServerErrors;
  public activeBlock: string;
  public userSubscription: UserSubscription;
  public websites: Website[];
  public subscriptionId: Website[];
  public pluginSlug: Website[];
  public recaptchaToken: any;
  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _authService: AuthService,
    private _store: Store<DbStoreState>,
    private _userService: UserService,
    private reCaptchaV3Service: ReCaptchaV3Service,
    private elementRef: ElementRef,
    private _pluginConnectService: PluginConnectService,
  ) {

  }
  ngOnInit(): void {
    this.serverErrors = null;
    this.activeBlock = "google-authenticator";
    this.formSubmitted = false;
    this.login2faForm = new FormGroup({
      login2faCode: new FormControl("", [Validators.required]),
      email: new FormControl(this.email),
      password: new FormControl(this.password),
    });
  }
  ngAfterViewInit() {
    setTimeout( () => {
      const el = this.elementRef && this.elementRef.nativeElement.querySelector('.login2faCode');
      if (el) {
        el.focus();
      }
    }, 1000);
  }
  public onSubmit(): void {
    this.formSubmitted = true;

    if ( this.login2faForm.valid) {
      this.loading = true;
      this.serverErrors = null;
      this.loginWith2fa.emit(this.login2faForm.value);
/*      if (this.enabledRecaptcha) {
        this.reCaptchaV3Service.execute(Config.googleRecaptcha, 'signup', (token) => {
          this.recaptchaToken = token;
          this._authService.login(this.login2faForm.value, false, this.recaptchaToken, this.activeBlock === 'google-recovery')
            .pipe(filter((response: DbResponse): boolean => !!response),
              first())
            .subscribe((response: DbResponse): void => {
              this.loading = false;
              if (response.success) {
                this._store.select(fromStore.getUserLoaded)
                  .pipe(
                    first((loaded: boolean) => loaded),
                    switchMap(() =>
                      combineLatest(
                        this._store.select(fromStore.getUserLoaded)
                          .pipe(
                            filter((userLoaded: boolean) => userLoaded),
                            switchMap(() => this._store.select(fromStore.getUserSubscription)),
                            first()
                          ),
                        this._store.select(fromStore.getWebsitesLoaded)
                          .pipe(
                            filter((websitesLoaded: boolean) => websitesLoaded),
                            switchMap(() =>
                              this._store.select(fromStore.getWebsites)
                            ),
                            first()
                          )
                      )
                    ),
                    takeUntil(this._destroyStream$)
                  )
                  .subscribe((data: any) => {
                    this.userSubscription = data[0];
                    this.websites = data[1];
                    if (!this.websites.length && this.userSubscription && (this.userSubscription.type === UserSubscriptionType.ONE_PRODUCT || this.userSubscription.type === UserSubscriptionType.PREMIUM)) {
                      this._router.navigate(['/add-website']);
                    }
                    else {
                      if (this.isLoginFromManager) {
                        this.finishLoginFromManager();
                      }
                      else if (this._isLoginFromZendesk) {
                        this.finishLoginFromZendesk();
                      }
                      else if (this.subscriptionId) {
                        if (response.data && TypeUtils.isDefined(response.data.logged_in) && !Utils.isTruthy(response.data.logged_in)) {
                          this._router.navigate(['/websites'], {
                            queryParams: {
                              subscr_id: this.subscriptionId,
                              plugin_slug: this.pluginSlug,
                              logged_in: response.data.logged_in
                            }
                          });
                        }
                        else {
                          this._router.navigate(['/websites'], {
                            queryParams: {
                              subscr_id: this.subscriptionId,
                              plugin_slug: this.pluginSlug
                            }
                          });
                        }
                      }
                      else if (response.data && TypeUtils.isDefined(response.data.logged_in) && !Utils.isTruthy(response.data.logged_in)) {
                        this._router.navigate(['/websites'], {
                          queryParams: {
                            subscr_id: this.subscriptionId,
                            plugin_slug: this.pluginSlug,
                            logged_in: response.data.logged_in
                          }
                        });
                      }
                      else {
                        this._router.navigate([this._route.snapshot.queryParams['returnUrl'] || '/'], {
                          queryParams: {
                            subscr_id: this.subscriptionId,
                            plugin_slug: this.pluginSlug,
                            logged_in: response.data.logged_in
                          }
                        });
                      }
                    }
                  });
              }
              else {
                this.loading = false;
                if (response.serverErrors && response.serverErrors.message !== "Client is not verified") {
                  this.serverErrors = response.serverErrors;
                }
              }
            });
        });
      }
      else {
        this._authService.login(this.login2faForm.value, false, this.recaptchaToken, this.activeBlock === 'google-recovery')
          .pipe(filter((response: DbResponse): boolean => !!response),
            first())
          .subscribe((response: DbResponse): void => {
            // this.loading = false;
            if (response.success) {
              this._store.select(fromStore.getUserLoaded)
                .pipe(
                  first((loaded: boolean) => loaded),
                  switchMap(() =>
                    combineLatest(
                      this._store.select(fromStore.getUserLoaded)
                        .pipe(
                          filter((userLoaded: boolean) => userLoaded),
                          switchMap(() => this._store.select(fromStore.getUserSubscription)),
                          first()
                        ),
                      this._store.select(fromStore.getWebsitesLoaded)
                        .pipe(
                          filter((websitesLoaded: boolean) => websitesLoaded),
                          switchMap(() =>
                            this._store.select(fromStore.getWebsites)
                          ),
                          first()
                        )
                    )
                  ),
                  takeUntil(this._destroyStream$)
                )
                .subscribe((data: any) => {
                  this.userSubscription = data[0];
                  this.websites = data[1];
                  if (!this.websites.length && this.userSubscription && (this.userSubscription.type === UserSubscriptionType.ONE_PRODUCT || this.userSubscription.type === UserSubscriptionType.PREMIUM)) {
                    this._router.navigate(['/add-website']);
                  }
                  else {
                    if (this.isLoginFromManager) {
                      this.finishLoginFromManager();
                    }
                    else if (this._isLoginFromZendesk) {
                      this.finishLoginFromZendesk();
                    }
                    else if (this.subscriptionId) {
                      if (response.data && TypeUtils.isDefined(response.data.logged_in) && !Utils.isTruthy(response.data.logged_in)) {
                        this._router.navigate(['/websites'], {
                          queryParams: {
                            subscr_id: this.subscriptionId,
                            plugin_slug: this.pluginSlug,
                            logged_in: response.data.logged_in
                          }
                        });
                      }
                      else {
                        this._router.navigate(['/websites'], {
                          queryParams: {
                            subscr_id: this.subscriptionId,
                            plugin_slug: this.pluginSlug
                          }
                        });
                      }
                    }
                    else if (response.data && TypeUtils.isDefined(response.data.logged_in) && !Utils.isTruthy(response.data.logged_in)) {
                      this._router.navigate(['/websites'], {
                        queryParams: {
                          subscr_id: this.subscriptionId,
                          plugin_slug: this.pluginSlug,
                          logged_in: response.data.logged_in
                        }
                      });
                    }
                    else {
                      this._router.navigate([this._route.snapshot.queryParams['returnUrl'] || '/'], {
                        queryParams: {
                          subscr_id: this.subscriptionId,
                          plugin_slug: this.pluginSlug,
                          logged_in: response.data.logged_in
                        }
                      });
                    }
                  }
                });
            }
            else {
              this.loading = false;
              if (response.serverErrors && response.serverErrors.message !== "Client is not verified") {
                this.serverErrors = response.serverErrors;
              }
            }
          });
      }*/
    }
  }

  public changeBlock() {
    this.login2faForm.controls['login2faCode'].setErrors({'incorrect': true});
    this.login2faForm.controls['login2faCode'].markAsUntouched();
    this.formSubmitted = false;
    this.serverErrors = null;
    if (this.activeBlock === "google-authenticator") {
      this.activeBlock = 'google-recovery';
    }
    else {
      this.activeBlock = "google-authenticator";
    }
    setTimeout( () => {
      const el = this.elementRef && this.elementRef.nativeElement.querySelector('.login2faCode');
      if (el) {
        el.focus();
      }
    }, 1000);
  }




  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.onSubmit();
    }
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }
}

